<template>
  <div id="app">
    <header-page></header-page>
    <router-view></router-view>
    <footer-page></footer-page>
  </div>
</template>

<script>
import HeaderPage from "./components/Header.vue";
import FooterPage from "./components/Footer.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
// import { store } from './store.js'
@Component({ components: { HeaderPage, FooterPage } })
export default class Com extends Vue {
  created() {
    this.$store.dispatch("updateXml");
    // this.$store.dispatch('updateLang', { lang: lang, i18n: this.$i18n });
  }
  get lang() {
    return this.$store.state.lang;
  }
  @Watch("lang")
  onLangChange() {
    this.$store.dispatch("updateXml");
  }
}
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  /* margin-top: 20px; */
}
.van-button--primary {
  background-color: #468dff !important;
}
@media screen and (max-width: 1200px) {
  .el-form-item__label {
    font-size: 0.32rem !important;
  }
  .el-input-number {
    transform: scale(1.8);
    transform-origin: left;
  }
  .el-form-item__content {
    font-size: 0.3733rem !important;
  }
  .el-slider__runway {
    height: 0.2133rem !important;
    border-radius: 0.1333rem !important;
  }
  .el-slider__button {
    height: 0.3467rem !important;
    width: 0.3467rem !important;
  }
  .el-slider__bar {
    height: 0.2133rem !important;
    border-radius: 0.1333rem !important;
  }
  .el-tooltip__popper {
    font-size: 0.32rem !important;
  }
  .el-form-item {
    margin-bottom: 0.6667rem !important;
  }
  /* .el-slider__button-wrapper {
  top: -.2367rem !important;
} */
}
</style>
